module.exports = __webpack_public_path__ + "static/RR_Front_Big-900f62b4bc3efe268acf7cbc43699fa3.png";